export default __webpack_public_path__ + "static/media/logo_head_blue.af7eab7e.png";